












import { Component, Mixins } from 'vue-property-decorator'

import FileUrlsList from '../../../File/FileUrlsList.vue'
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput } from '../../mixins'
import { FileUrlsListInputData } from './types'

@Component({
  components: {
    FieldWrapper,
    FileUrlsList,
  },
})
export default class FileUrlsListInput extends Mixins(BaseInput) {
  get availableTypes(): Array<string> | undefined {
    return (this.settings as FileUrlsListInputData).availableTypes
  }

  get availableMimeTypes(): Array<string> | null {
    if (!this.availableTypes) {
      return null
    }

    const mimeTypes: Array<string> = []

    if (this.availableTypes.includes('image')) {
      mimeTypes.push(...[ 'image/jpeg', 'image/pjpeg', 'image/png', 'image/gif', 'image/svg+xm',
        'image/tiff', 'image/vnd.microsoft.icon', 'image/vnd.wap.wbmp', 'image/webp' ])
    }

    return mimeTypes
  }
}
